import n from "react";
import { css as e, cx as r } from "@leafygreen-ui/emotion";
import o from "prop-types";
import t from "@leafygreen-ui/box";
import { isComponentType as a } from "@leafygreen-ui/lib";
import { uiColors as i } from "@leafygreen-ui/palette";
import { isComponentGlyph as l } from "@leafygreen-ui/icon";
import { validateAriaLabelProps as c } from "@leafygreen-ui/a11y";
import { jsx as s } from "@emotion/react";
function f(n, e) {
  var r = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);
    e && (o = o.filter(function (e) {
      return Object.getOwnPropertyDescriptor(n, e).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function u(n) {
  for (var e = 1; e < arguments.length; e++) {
    var r = null != arguments[e] ? arguments[e] : {};
    e % 2 ? f(Object(r), !0).forEach(function (e) {
      b(n, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : f(Object(r)).forEach(function (e) {
      Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }
  return n;
}
function b(n, e, r) {
  return e in n ? Object.defineProperty(n, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = r, n;
}
function d() {
  return (d = Object.assign || function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
    }
    return n;
  }).apply(this, arguments);
}
function g(n, e) {
  if (null == n) return {};
  var r,
    o,
    t = function (n, e) {
      if (null == n) return {};
      var r,
        o,
        t = {},
        a = Object.keys(n);
      for (o = 0; o < a.length; o++) r = a[o], e.indexOf(r) >= 0 || (t[r] = n[r]);
      return t;
    }(n, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    for (o = 0; o < a.length; o++) r = a[o], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function p(n, e) {
  return e || (e = n.slice(0)), Object.freeze(Object.defineProperties(n, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}
var y,
  h,
  m,
  k,
  v,
  O,
  w,
  j,
  x,
  P,
  S,
  z,
  D,
  N,
  I,
  C,
  E = ["size", "darkMode", "disabled", "active", "className", "children"],
  L = "light",
  M = "dark",
  B = {
    Default: "default",
    Large: "large",
    XLarge: "xlarge"
  },
  X = e(y || (y = p(["\n  border: none;\n  -webkit-appearance: unset;\n  padding: unset;\n"]))),
  R = e(h || (h = p(["\n  display: inline-block;\n  border-radius: 100px;\n  color: ", ";\n  position: relative;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: color 150ms ease-in-out;\n\n  // Set background to fully-transparent white for cross-browser compatability with Safari\n  //\n  // Safari treats \"transparent\" values in CSS as transparent black instead of white\n  // which can make things render differently across browsers if not defined explicitly.\n  background-color: rgba(255, 255, 255, 0);\n\n  &:before {\n    content: '';\n    transition: 150ms all ease-in-out;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-radius: 100%;\n    opacity: 0;\n    transform: scale(0.8);\n  }\n\n  &:active:before,\n  &:hover:before,\n  &:focus:before {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  &:focus {\n    outline: none;\n  }\n"])), i.gray.base),
  T = (b(O = {}, B.Default, e(m || (m = p(["\n    height: 28px;\n    width: 28px;\n  "])))), b(O, B.Large, e(k || (k = p(["\n    height: 35px;\n    width: 35px;\n  "])))), b(O, B.XLarge, e(v || (v = p(["\n    height: 42px;\n    width: 42px;\n  "])))), O),
  q = (b(x = {}, L, e(w || (w = p(["\n    &:active,\n    &:hover {\n      color: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n\n    &:focus {\n      color: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n  "])), i.gray.dark2, i.gray.light2, i.blue.dark2, i.blue.light2)), b(x, M, e(j || (j = p(["\n    &:active,\n    &:hover {\n      color: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n\n    &:focus {\n      color: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n  "])), i.white, i.gray.dark2, i.blue.light1, i.blue.dark2)), x),
  A = (b(z = {}, L, e(P || (P = p(["\n    color: ", ";\n    pointer-events: none;\n    background-color: rgba(255, 255, 255, 0);\n\n    &:focus {\n      color: ", ";\n      &:before {\n        background-color: ", ";\n      }\n    }\n  "])), i.gray.light2, i.gray.light2, i.gray.light1)), b(z, M, e(S || (S = p(["\n    color: ", ";\n    pointer-events: none;\n    background-color: rgba(255, 255, 255, 0);\n\n    &:focus {\n      color: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n  "])), i.gray.dark2, i.gray.dark2, i.gray.dark1)), z),
  F = (b(I = {}, L, e(D || (D = p(["\n    color: ", ";\n    background-color: ", ";\n\n    &:before {\n      background-color: ", ";\n    }\n  "])), i.gray.dark2, i.gray.light2, i.gray.light2)), b(I, M, e(N || (N = p(["\n    color: ", ";\n    background-color: ", ";\n\n    &:before {\n      background-color: ", ";\n    }\n  "])), i.white, i.gray.dark2, i.gray.dark2)), I),
  G = e(C || (C = p(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]))),
  H = n.forwardRef(function (e, o) {
    var i,
      f,
      p = e.size,
      y = void 0 === p ? B.Default : p,
      h = e.darkMode,
      m = void 0 !== h && h,
      k = e.disabled,
      v = void 0 !== k && k,
      O = e.active,
      w = void 0 !== O && O,
      j = e.className,
      x = e.children,
      P = g(e, E),
      S = m ? "dark" : "light";
    c(P, "IconButton");
    var z = n.Children.map(x, function (e) {
        if (!e) return null;
        if (a(e, "Icon") || l(e)) {
          var r = e.props,
            o = r.size,
            t = r.title,
            i = {
              size: o || y
            };
          return "string" == typeof t && 0 !== t.length || (i.title = !1), n.cloneElement(e, i);
        }
        return e;
      }),
      D = u(u({}, P), {}, (b(f = {
        ref: o,
        tabIndex: 0
      }, "aria-disabled", v), b(f, "href", v ? void 0 : P.href), b(f, "onClick", v ? void 0 : P.onClick), b(f, "className", r(X, R, T[y], q[S], (b(i = {}, F[S], w), b(i, A[S], v), i), j)), f));
    return "string" == typeof P.href ? s(t, d({
      as: "a"
    }, D), s("div", {
      className: G
    }, z)) : s(t, d({
      as: "button"
    }, D), s("div", {
      className: G
    }, z));
  });
H.displayName = "IconButton", H.propTypes = {
  darkMode: o.bool,
  size: o.oneOf(Object.values(B)),
  className: o.string,
  children: o.node,
  disabled: o.bool,
  href: o.string,
  active: o.bool
};
export default H;
export { B as Size };